import { parseToken } from '../../../utils/index';

export const ACCESS_TOKEN_KEY = 'AUTH_ACC';
export const REFESH_TOKEN_KEY = 'AUTH_REF';

export function setCookie(cookieName: string, value: Record<string, string>) {
  const cookie_value =
    escape(JSON.stringify(value)) +
    '; expires=' +
    new Date(parseToken(value.access).exp * 1000).toUTCString() +
    ';path=/';
  document.cookie = cookieName + '=' + cookie_value;
}

export function getCookie(cookieName: string) {
  let cookieValue = '';
  const cookie = document.cookie;
  if (cookie) {
    const array = cookie.split(escape(cookieName) + '=');
    if (array.length >= 2) {
      const arraySub = array[1].split(';');
      cookieValue = unescape(arraySub[0]);
    }
  }
  return cookieValue;
}

export function removeCookie(key: string) {
  const todayDate = new Date();
  document.cookie = key + '=; expires=' + todayDate.toUTCString() + ';'; // 현재 시각 이전이면 쿠키가 만료되어 사라짐.
}

export function getAccessToken() {
  const auth = getCookie(ACCESS_TOKEN_KEY) || '{}';
  const authJson = JSON.parse(auth);
  return authJson;
}

export function getRefreshToken() {
  const auth = getCookie(REFESH_TOKEN_KEY) || '{}';
  // const access = getLocalStorage('access_token');
  const authJson = JSON.parse(auth);
  return authJson;
}
